const localeText = {
  addColorDisabledTooltip: "Color limit reached, delete a color to add more.",
  addColorTooltip: "Add Color",
  deleteColorTooltip: "Delete Color",
  footerButtonAddColor: "Add Color",
  footerButtonCancel: "Cancel",
  footerButtonCommit: "Save",
  noColorLabel: "No Color",
  pickerAdornmentTooltip: "Copy to clipboard",
  pickerAdornmentTooltipCopied: "Copied",
  randomColorActionTooltip: "Random Color",
  tabCustomLabel: "Custom",
  tabPaletteLabel: "Palette",
  triggerButtonLabel: "Button trigger label",
  triggerSelectLabel: "Select trigger label"
};
export {
  localeText
};
//# sourceMappingURL=localeText.js.map
